
import React, { useContext, useState } from "react";
import { useTheme } from "@mui/material/styles";
import {
  Box,
  Typography,
  List,
  ListItemButton,
  ListItemText,
  Collapse,
  Divider,
  Grid,
  TextField,
  Dialog,
  DialogContent,
  DialogTitle,
  InputAdornment,
  IconButton,
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { useParams, useNavigate } from "react-router-dom";
import PostmanDoc from "./Postman.jsx";
import { documentationData } from "./data/documentdata.js";
import PostmanRealAPi from "./postmanapi/PostmanRealAPi.jsx";
import PostmanLogin from "./postmanapi/PostmanLogin.jsx";
import AccessToken from "./postmanapi/AccessToken.jsx";
import { AuthContext } from "./utils/AuthContext.js";
import PleaseEnterTokenCard from "./utils/PleaseEnterTokenCard.jsx";
import { Visibility, VisibilityOff } from "@mui/icons-material";

function flattenAllItems(data) {
  let flat = [];
  data.forEach((section) => {
    section.items.forEach((item) => {
      if (item.children) {
        item.children.forEach((child) => {
          flat.push({ ...child, parent: item.label, section: section.title });
        });
      } else {
        flat.push({ ...item, section: section.title });
      }
    });
  });
  return flat;
}

function Sidebar({ data, selectedId, openItems, onCollapse, onSelect }) {
  const theme = useTheme();

  return (
    <List component="nav" dense sx={{
      '& .MuiListItemButton-root': {
        borderRadius: 1,
        px: 2,
        '&:hover': {
          backgroundColor: theme.palette.action.hover
        },
        '&.Mui-selected': {
          backgroundColor: theme.palette.action.selected,
          '&:hover': {
            backgroundColor: theme.palette.action.selected
          }
        }
      }
    }}>
      {data.map((section) => (
        <React.Fragment key={section.id}>
          {section.items.map((item) => {
            if (item.children) {
              return (
                <React.Fragment key={item.id}>
                  <ListItemButton onClick={() => onCollapse(item.id)}>
                    <ListItemText
                      primary={item.label}
                      primaryTypographyProps={{
                        fontWeight: 600
                        //  openItems[item.id] ? 600 : 'normal'
                      }}
                    />
                    {openItems[item.id] ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                  <Collapse in={openItems[item.id]} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {item.children.map((child) => (
                        <ListItemButton
                          key={child.id}
                          sx={{
                            ml: 2,

                            ...(selectedId === child.id || selectedId === child.id ? {

                              '&::before': {
                                content: '""',
                                position: 'absolute',
                                left: 0,
                                top: 6,
                                bottom: 6,
                                width: 4,
                                borderRadius: '0 4px 4px 0',
                                background: ' #6a11cb',
                                zIndex: 1,
                              },
                            } : {}),
                          }}
                          selected={selectedId === child.id}
                          onClick={() => onSelect(child)}

                        >
                          <ListItemText
                            primary={child.label}
                            primaryTypographyProps={{
                              fontWeight: selectedId === child.id ? 600 : 'normal'
                            }}
                          />
                        </ListItemButton>
                      ))}
                    </List>
                  </Collapse>

                </React.Fragment>
              );
            }
            return (
              <ListItemButton
                key={item.id}
                selected={selectedId === item.id}
                onClick={() => onSelect(item)}
              >
                <ListItemText
                  primary={item.label}
                  primaryTypographyProps={{
                    fontWeight: selectedId === item.id ? 600 : 'normal'
                  }}
                />
              </ListItemButton>
            );
          })}
        </React.Fragment>
      ))}

    </List>
  );
}

export default function Documentpage() {
  const theme = useTheme();
  const { id } = useParams();
  const [openDialog, setOpenDialog] = useState(false);


  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const { myOrgName, tenantCode, token, baseUrl } = useContext(AuthContext);
  const navigate = useNavigate();
  const docuData = documentationData(myOrgName, token, tenantCode, baseUrl);
  //  const docuDataReal = documentationDataRealData(myOrgName);

  const [showToken, setShowToken] = useState(false);
  const flatItems = flattenAllItems(docuData);
  const [myrole, setMyrole] = useState(false)

  // Find the selected item by id from URL, or default to first
  const selected = flatItems.find((item) => item.id === id);

  // Manage open/closed state for collapses
  const [openItems, setOpenItems] = React.useState(
    () => {
      if (selected && selected.parent) {
        // Open the parent if a child is selected
        const parentItem = docuData
          .flatMap((section) => section.items)
          .find((item) => item.label === selected.parent);
        return parentItem ? { [parentItem.id]: true } : {};
      }
      return {};
    }
  );

  // When URL changes, open the correct collapse
  React.useEffect(() => {
    if (selected && selected.parent) {
      const parentItem = docuData
        .flatMap((section) => section.items)
        .find((item) => item.label === selected.parent);
      if (parentItem) {
        setOpenItems((prev) => ({ ...prev, [parentItem.id]: true }));
      }
    }
  }, [id]);

  const handleSidebarSelect = (item) => {
    navigate(`/section/${item.id}`);
  };

  const handleCollapseToggle = (itemId) => {
    setOpenItems((prev) => ({
      ...prev,
      [itemId]: !prev[itemId],
    }));
  };

  if (!selected) {
    return (
      <Box sx={{ p: 4 }}>
        <Typography
          onClick={() => navigate(`/`)}
          variant="body1"
          sx={{
            mb: 2,
            fontWeight: 600,
            color: 'primary.main',
            cursor: 'pointer',
            '&:hover': {
              textDecoration: 'underline'
            }
          }}
        >
          Home
        </Typography>
        <Typography variant="h4" color="error">
          Not Found
        </Typography>
        <Typography>
          The documentation page you requested does not exist.
        </Typography>
      </Box>
    );
  }
  const isApiReady =
    Boolean(token?.length) &&
    Boolean(myOrgName) &&
    Boolean(tenantCode) &&
    Boolean(baseUrl);


  const hasApiEndpoints =
    Array.isArray(selected?.content?.apiendpoints) &&
    selected.content.apiendpoints.length > 0;

  return (
    <Box sx={{
      display: "flex",
      minHeight: "80vh",
      bgcolor: 'background.default'
    }}>
      {/* Sidebar */}
      {selected &&
        <>
          <Box
            sx={{
              width: '20vw',
              borderRight: `1px solid ${theme.palette.divider}`,
              bgcolor: 'background.paper',
              p: 2,
              minHeight: "100%",
              position: 'sticky',
              top: 0,
              height: '100vh',
              overflowY: 'auto'
            }}
          >
            <Typography
              onClick={() => navigate(`/`)}
              variant="body1"
              sx={{
                mb: 2,
                fontWeight: 600,
                color: 'primary.main',
                cursor: 'pointer',
                '&:hover': {
                  textDecoration: 'underline'
                }
              }}
            >
              Home
            </Typography>
            <Typography variant="h6" sx={{
              mb: 2,
              fontWeight: 600,
              color: 'text.primary'
            }}>
              Documentation
            </Typography>

            <Sidebar
              data={docuData}
              selectedId={selected.id}
              openItems={openItems}
              onCollapse={handleCollapseToggle}
              onSelect={handleSidebarSelect}
            />
          </Box>

          <Box sx={{
            flex: 1,
            p: 1,
            bgcolor: 'background.default'
          }}>
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              mb: 2
            }}>
              <Box className="formHolder__logo">
                {/* <img src={logoImgOnlyS} alt="" width={70} /> */}
              </Box>
              <Typography  sx={{
                fontWeight: 600,
                color: 'text.primary'
              }}>
                {selected.content?.title || selected.label}
              </Typography>
            </Box>
            <Divider sx={{ mb: 3 }} />
            {selected.section && (
              <Typography variant="subtitle1" color="text.secondary" gutterBottom>
                Section: {selected.section}
              </Typography>
            )}

            {/* <TextField
                            type="text"
                            value={myOrgName}
                            onChange={e => setMyOrgName(e.target.value)}
                            placeholder="orgname"
                            style={{ marginLeft: 6, marginBottom: 8 }}
                          /> */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                mb: 2,
              }}
            >
              <IconButton
                size="small"
                onClick={() => setShowToken(prev => !prev)}
                aria-label={showToken ? 'Hide sensitive details' : 'Show sensitive details'}
                sx={{
                  border: '1px solid',
                  borderColor: showToken ? 'error.main' : 'primary.main',
                  borderRadius: 1,
                  px: 1.5,
                }}
              >
                {showToken ? <VisibilityOff /> : <Visibility />}
              </IconButton>

              <Typography
                variant="body2"
                sx={{ fontWeight: 500 }}
              >
                {showToken ? 'Hide Secret Details' : 'Show Secret Details'}
              </Typography>
            </Box>

            {showToken && <AccessToken />}

            <Grid container spacing={0} alignItems="stretch">

              <Grid item size={hasApiEndpoints ? 6 : 12}>
                <Box sx={{ height: '100%', p: 2, bgcolor: 'background.paper' }}>

                  {selected.content?.description || "No details available."}
                </Box>
              </Grid>
              <Grid item size={6}>
                <Box sx={{
                  height: '100%', boxShadow: '0 2px 8px #0001',
                  bgcolor: 'background.paper'
                  // bgcolor: 'transparent'
                }}>

                  {selected?.content?.apiendpoints?.map((item, index) => (
                    <>

                      {isApiReady ? <PostmanRealAPi
                        key={`${item.id}-${index}-${tenantCode}-${token}`}
                        endpoint={item} token={token} myOrgName={myOrgName} /> :
                        <PleaseEnterTokenCard onGetTokenClick={handleOpenDialog} />}

                      <Dialog onClose={handleCloseDialog} open={openDialog}>
                        <DialogTitle>Enter API Token</DialogTitle>
                        <DialogContent>
                          {/* Pass any props to AccessToken if needed */}
                          <AccessToken />
                        </DialogContent>
                      </Dialog>
                    </>

                  ))}
                  {/* {myrole
        ? selected?.content?.apiendpoints?.map((item, index) => (
            <Box key={index} sx={{ mb: 4 }}>
              Postman dummy
              <PostmanRealAPi endpoint={item} />
            </Box>
          ))
        : selected?.content?.endpoints?.map((item, index) => (
            
              <PostmanDoc endpoint={item} />
           
          ))} */}
                </Box>
              </Grid>
            </Grid>





          </Box>
        </>
      }
    </Box>
  );
}